import React from 'react';
import PropTypes from 'prop-types';

import './AwardCell.css';
import Star from '../../../images/publications/star.svg';

const AwardCell = ({
  award: {
    title, category, year, event, project,
  },
  scrollID,
  emptyCell,
}) => {
  if (emptyCell) {
    return <div className="AwardCell EmptyAwardCell" />;
  }

  return (
    <div className="AwardCell" id={scrollID}>
      <h3 className="CellText">{`${event} ${year}`.toUpperCase()}</h3>
      <h1 className="CellText">{title}</h1>
      <h2 className="CellText">{category}</h2>
      { project && (
        <h4>
          <img src={Star} alt="star icon" />
          {project}
        </h4>
      )}
    </div>
  );
};

AwardCell.propTypes = {
  award: PropTypes.shape({
    title: PropTypes.string,
    category: PropTypes.string,
    year: PropTypes.string,
    event: PropTypes.string,
  }),
  scrollID: PropTypes.string,
  emptyCell: PropTypes.bool,
};

AwardCell.defaultProps = {
  award: {},
  scrollID: '',
  emptyCell: false,
};

export default AwardCell;
